import { TileRefreshStatus, TileRefreshStatusFactory } from "./tiles";

/** Controller for tile layout example */
export class TilelayoutHarnessController {
  public colors: any;
  public label = "Expand Content";
  public textAreaModel: string;
  public display = false;
  public radio1: string;
  public radio2: string;
  public items: Array<any> = [
    { Text: "One", Value: 1 },
    { Text: "Two", Value: 2 }
  ];
  public selectedItem: any;
  public selectOptions: Array<string>;
  public selectedItem2: any;
  public selectOptions2: Array<any>;
  public selectedIndex = 3;
  public refreshStatus: TileRefreshStatus;
  // @ngInject
  constructor(private $state: ng.ui.IStateService, tileRefreshStatusFactory: TileRefreshStatusFactory) {
    this.textAreaModel = "Sample text area text.";
    this.colors = { red: true, green: false, blue: true };
    this.selectOptions = ["option1", "option2", "option3", "option4"];
    this.selectedItem = this.selectOptions[this.selectedIndex];
    this.selectOptions2 = [
      { itemId: "1", name: "red", theme: "dark" },
      { itemId: "2", name: "green", theme: "dark" },
      { itemId: "3", name: "blue", theme: "dark" },
      { itemId: "4", name: "yellow", theme: "dark" }
    ];
    this.selectedItem2 = this.selectOptions2[1];
    this.refreshStatus = tileRefreshStatusFactory.createTileRefreshStatusObject();
    this.refreshStatus.setToSucceeded();
  }

  radio1Selected(item: any): void {
    this.radio1 = item;
  }

  radio2Selected(item: any): void {
    this.radio2 = item;
  }

  public buttonCliked() {
    if (this.display) {
      this.label = "Expand Content";
    } else {
      this.label = "Collapse Content";
    }
    this.display = !this.display;
  }

  public onRefresh() {
    window.alert("Refresh clicked.");
    this.refreshStatus.setToSucceeded();
  }

  public gotoFormPage() {
    this.$state.go("sdForm");
  }

  public gotoTileLayout() {
    this.$state.go("tileLayout");
  }

  public onCheckBoxChanged(item: any) {
    window.alert("Checkbox changed " + item);
  }

  public updateSelectModel() {
    this.selectedIndex = this.selectedIndex === 3 ? 1 : 3;
    this.selectedItem = this.selectOptions[this.selectedIndex];
  }

  public selectChanged(selectedItem: any) {
    window.alert("Option changed. " + JSON.stringify(selectedItem));
  }
}
